// extracted by mini-css-extract-plugin
module.exports = {"b-form-item":"BFormItem_b-form-item__o6U6C"};